import React, { useEffect, useState } from "react"
import QRCodeLib from "qrcode"

export default function QRCode({
  value,
  size = 128,
  ecl = "M",
}: {
  value: string
  size?: number
  ecl?: "L" | "M" | "Q" | "H" | string
}) {
  const [src, setSrc] = useState("")

  useEffect(() => {
    let cancelled = false
    QRCodeLib.toDataURL(value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: (["L", "M", "Q", "H"].includes(ecl) ? ecl : "M") as "L" | "M" | "Q" | "H",
    })
      .then((dataUrl) => {
        if (!cancelled) setSrc(dataUrl)
      })
      .catch(() => {
        if (!cancelled) setSrc("")
      })
    return () => {
      cancelled = true
    }
  }, [value, size, ecl])

  if (!src) {
    return <div style={{ width: size, height: size }} aria-hidden />
  }

  return <img src={src} alt="qrcode" width={size} height={size} />
}
